module.exports = __webpack_public_path__ + "img/de15823.jpg";